/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationRequestDTO
 */
export interface AuthenticationRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    scope?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    responseType?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationRequestDTO
     */
    request?: string;
}

export function AuthenticationRequestDTOFromJSON(json: any): AuthenticationRequestDTO {
    return AuthenticationRequestDTOFromJSONTyped(json, false);
}

export function AuthenticationRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'responseType': !exists(json, 'response_type') ? undefined : json['response_type'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'nonce': !exists(json, 'nonce') ? undefined : json['nonce'],
        'request': !exists(json, 'request') ? undefined : json['request'],
    };
}

export function AuthenticationRequestDTOToJSON(value?: AuthenticationRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'scope': value.scope,
        'response_type': value.responseType,
        'state': value.state,
        'nonce': value.nonce,
        'request': value.request,
    };
}

